/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateOrchestrationEntitlementDto
 */
export interface CreateOrchestrationEntitlementDto {
    /**
     * ID of the entitlement (for updates)
     * @type {string}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'id'?: string;
    /**
     * Name of the entitlement
     * @type {string}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'name': string;
    /**
     * Description of the entitlement
     * @type {string}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'description'?: string;
    /**
     * Whether this entitlement is optional
     * @type {boolean}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'isOptional': boolean;
    /**
     * Price amount for this entitlement
     * @type {number}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'priceAmount': number;
    /**
     * Remaining quantity available for this entitlement
     * @type {number}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'remainingQuantity': number;
    /**
     * Array of image URLs for this entitlement
     * @type {Array<string>}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'imageUrls': Array<string>;
    /**
     * Display order for sorting entitlements in UI
     * @type {number}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'displayOrder': number;
    /**
     * Type of entitlement
     * @type {string}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'type': CreateOrchestrationEntitlementDtoTypeEnum;
    /**
     * Whether this entitlement has unlimited quantity available
     * @type {boolean}
     * @memberof CreateOrchestrationEntitlementDto
     */
    'isUnlimited': boolean;
}

export const CreateOrchestrationEntitlementDtoTypeEnum = {
    Physical: 'physical',
    Digital: 'digital'
} as const;

export type CreateOrchestrationEntitlementDtoTypeEnum = typeof CreateOrchestrationEntitlementDtoTypeEnum[keyof typeof CreateOrchestrationEntitlementDtoTypeEnum];


